














































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import RoleApi from '@/api/identity/role/index'
import Permission from './operating/permission.vue'
@Component({
  components: {
    Permission
  }
})
export default class Roles extends AbpBase {
  showPermissionModal = false
  providerKey = ''
  isCheckAll: boolean = false
  loading: boolean = false
  currentPage = 1
  pageSize = 10
  totalCount = 0
  tableData: any[] = []
  columns: any[] = [
    {
      title: '角色名称',
      key: 'name',
      align: 'center'
    },
    {
      title: '是否启用',
      slot: 'isPublic',
      align: 'center'
    },
    {
      title: '操作',
      slot: 'action',
      width: 250,
      align: 'center'
    }
  ]

  mounted() {
    this.loadData()
  }
  loadData() {
    this.loading = true
    RoleApi.getRoles(this.pageSize, this.currentPage).then(res => {
      this.totalCount = res.data.totalCount
      this.tableData = res.data.items
      this.loading = false
    })
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  handleTableAllCancel() {
    this.isCheckAll = false
  }
  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }
  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }
  change(status) {
    this.$Message.info('开关状态：' + status)
  }
  addNewRole() {
    console.log('新增成员')
    this.$router.push({
      name: 'addRole'
    })
  }
  // 权限编辑
  editPermission(id?) {
    console.log(id)
    this.$router.push({
      name: 'editRole',
      query: {
        id
      }
    })
  }
  // 删除
  deletePermission(id) {
    console.log(id)
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        RoleApi.deleteRole(id).then(res => {
          this.$Message.success('删除成功')
          this.loadData()
        })
      }
    })
  }
  // 权限设置
  permissionSettings(item) {
    // console.log(id)
    // this.$router.push({
    //   name: 'authoritySet',
    //   query: {
    //     id
    //   }
    // })
    this.providerKey = item.name
    this.showPermissionModal = true
  }
}
